class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.allResetButtons = document.querySelectorAll('button[type="reset"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));

    // Agregar eventos para todos los botones de reset
    this.allResetButtons.forEach((button) => {
      button.addEventListener('click', this.onResetClick.bind(this));
    });
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
      this.updateAllResetButtons('');
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
    this.updateAllResetButtons(target.value);
  }

  onResetClick(event) {
    event.preventDefault();
    this.keepInSync('', null);
    this.updateAllResetButtons('');
    // Enfocar el primer input de búsqueda
    if (this.allSearchInputs.length > 0) {
      this.allSearchInputs[0].focus();
    }
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  updateAllResetButtons(value) {
    this.allResetButtons.forEach((button) => {
      if (value.length > 0) {
        button.classList.remove('hidden');
      } else {
        button.classList.add('hidden');
      }
    });
  }
}

customElements.define('main-search', MainSearch);
